export function OnboardImage1() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 390 493' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3383_11434)'>
        <g opacity='0.6'>
          <rect
            opacity='0.5'
            x='178.417'
            y='74.5273'
            width='52.0273'
            height='52.0273'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='284.032'
            y='21.5'
            width='52.0273'
            height='52.0273'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='284.032'
            y='127.555'
            width='52.0273'
            height='52.0273'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <g opacity='0.5'>
            <mask id='path-4-inside-1_3383_11434' fill='white'>
              <path d='M336.558 127.055H389.585V180.082H336.558V127.055Z' />
            </mask>
            <path
              d='M389.585 127.055H390.585V126.055H389.585V127.055ZM389.585 180.082V181.082H390.585V180.082H389.585ZM336.558 128.055H389.585V126.055H336.558V128.055ZM388.585 127.055V180.082H390.585V127.055H388.585ZM389.585 179.082H336.558V181.082H389.585V179.082Z'
              fill='var(--black)'
              fillOpacity='0.05'
              mask='url(#path-4-inside-1_3383_11434)'
            />
          </g>
          <rect
            opacity='0.5'
            x='125.5'
            y='180.503'
            width='52.0273'
            height='52.0273'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <mask id='path-7-inside-2_3383_11434' fill='white'>
            <path d='M230.946 74.0273H283.973V127.055H230.946V74.0273Z' />
          </mask>
          <path
            d='M230.946 127.055H229.946V128.055H230.946V127.055ZM283.973 126.055H230.946V128.055H283.973V126.055ZM231.946 127.055V74.0273H229.946V127.055H231.946Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-7-inside-2_3383_11434)'
          />
          <mask id='path-9-inside-3_3383_11434' fill='white'>
            <path d='M230.946 127.055H283.973V180.082H230.946V127.055Z' />
          </mask>
          <path
            d='M283.973 179.082H230.946V181.082H283.973V179.082Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-9-inside-3_3383_11434)'
          />
          <mask id='path-11-inside-4_3383_11434' fill='white'>
            <path d='M336.558 74.0273L336.558 127.055L283.531 127.055L283.531 74.0273L336.558 74.0273Z' />
          </mask>
          <path
            d='M335.558 74.0273L335.558 127.055L337.558 127.055L337.558 74.0273L335.558 74.0273ZM284.531 127.055L284.531 74.0273L282.531 74.0273L282.531 127.055L284.531 127.055Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-11-inside-4_3383_11434)'
          />
          <mask id='path-13-inside-5_3383_11434' fill='white'>
            <path d='M177.917 127.055H230.945V180.082H177.917V127.055Z' />
          </mask>
          <path
            d='M230.945 180.082V181.082H231.945V180.082H230.945ZM177.917 180.082H176.917V181.082H177.917V180.082ZM229.945 127.055V180.082H231.945V127.055H229.945ZM230.945 179.082H177.917V181.082H230.945V179.082ZM178.917 180.082V127.055H176.917V180.082H178.917Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-13-inside-5_3383_11434)'
          />
          <mask id='path-15-inside-6_3383_11434' fill='white'>
            <path d='M283.532 180.082H336.559V233.109H283.532V180.082Z' />
          </mask>
          <path
            d='M336.559 233.109V234.109H337.559V233.109H336.559ZM335.559 180.082V233.109H337.559V180.082H335.559ZM336.559 232.109H283.532V234.109H336.559V232.109Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-15-inside-6_3383_11434)'
          />
          <mask id='path-17-inside-7_3383_11434' fill='white'>
            <path d='M177.917 180.082H230.945V233.109H177.917V180.082Z' />
          </mask>
          <path
            d='M230.945 233.109V234.109H231.945V233.109H230.945ZM229.945 180.082V233.109H231.945V180.082H229.945ZM230.945 232.109H177.917V234.109H230.945V232.109Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-17-inside-7_3383_11434)'
          />
          <rect
            x='283.032'
            y='21.5'
            width='52.0273'
            height='52.0273'
            transform='rotate(90 283.032 21.5)'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <mask id='path-20-inside-8_3383_11434' fill='white'>
            <path d='M389.585 21L389.585 74.0273L336.558 74.0273L336.558 21L389.585 21Z' />
          </mask>
          <path
            d='M389.585 21L390.585 21L390.585 20L389.585 20L389.585 21ZM389.585 74.0273L389.585 75.0273L390.585 75.0273L390.585 74.0273L389.585 74.0273ZM388.585 21L388.585 74.0273L390.585 74.0273L390.585 21L388.585 21ZM389.585 73.0273L336.558 73.0273L336.558 75.0273L389.585 75.0273L389.585 73.0273ZM336.558 22L389.585 22L389.585 20L336.558 20L336.558 22Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-20-inside-8_3383_11434)'
          />
        </g>
        <g opacity='0.6'>
          <rect
            opacity='0.5'
            x='211.168'
            y='417.582'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 211.168 417.582)'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='105.553'
            y='470.609'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 105.553 470.609)'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='105.553'
            y='364.555'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 105.553 364.555)'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <g opacity='0.5'>
            <mask id='path-25-inside-9_3383_11434' fill='white'>
              <path d='M53.0272 365.055H-3.8147e-05V312.027H53.0272V365.055Z' />
            </mask>
            <path
              d='M-3.8147e-05 365.055H-1.00004V366.055H-3.8147e-05V365.055ZM-3.8147e-05 312.027V311.027H-1.00004V312.027H-3.8147e-05ZM53.0272 364.055H-3.8147e-05V366.055H53.0272V364.055ZM0.999962 365.055V312.027H-1.00004V365.055H0.999962ZM-3.8147e-05 313.027H53.0272V311.027H-3.8147e-05V313.027Z'
              fill='var(--black)'
              fillOpacity='0.05'
              mask='url(#path-25-inside-9_3383_11434)'
            />
          </g>
          <rect
            opacity='0.5'
            x='264.085'
            y='311.605'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 264.085 311.605)'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <mask id='path-28-inside-10_3383_11434' fill='white'>
            <path d='M158.639 418.082H105.612V365.054H158.639V418.082Z' />
          </mask>
          <path
            d='M158.639 365.054H159.639V364.054H158.639V365.054ZM105.612 366.054H158.639V364.054H105.612V366.054ZM157.639 365.054V418.082H159.639V365.054H157.639Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-28-inside-10_3383_11434)'
          />
          <mask id='path-30-inside-11_3383_11434' fill='white'>
            <path d='M158.639 365.055H105.612V312.027H158.639V365.055Z' />
          </mask>
          <path
            d='M105.612 313.027H158.639V311.027H105.612V313.027Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-30-inside-11_3383_11434)'
          />
          <mask id='path-32-inside-12_3383_11434' fill='white'>
            <path d='M53.0272 418.082L53.0272 365.054L106.054 365.054L106.054 418.082L53.0272 418.082Z' />
          </mask>
          <path
            d='M54.0272 418.082L54.0272 365.054L52.0272 365.054L52.0272 418.082L54.0272 418.082ZM105.054 365.054L105.054 418.082L107.054 418.082L107.054 365.054L105.054 365.054Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-32-inside-12_3383_11434)'
          />
          <mask id='path-34-inside-13_3383_11434' fill='white'>
            <path d='M211.668 365.055H158.64V312.027H211.668V365.055Z' />
          </mask>
          <path
            d='M158.64 312.027V311.027H157.64V312.027H158.64ZM211.668 312.027H212.668V311.027H211.668V312.027ZM159.64 365.055V312.027H157.64V365.055H159.64ZM158.64 313.027H211.668V311.027H158.64V313.027ZM210.668 312.027V365.055H212.668V312.027H210.668Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-34-inside-13_3383_11434)'
          />
          <mask id='path-36-inside-14_3383_11434' fill='white'>
            <path d='M106.053 312.027H53.026V259H106.053V312.027Z' />
          </mask>
          <path
            d='M53.026 259V258H52.026V259H53.026ZM54.026 312.027V259H52.026V312.027H54.026ZM53.026 260H106.053V258H53.026V260Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-36-inside-14_3383_11434)'
          />
          <mask id='path-38-inside-15_3383_11434' fill='white'>
            <path d='M211.668 312.027H158.64V259H211.668V312.027Z' />
          </mask>
          <path
            d='M158.64 259V258H157.64V259H158.64ZM159.64 312.027V259H157.64V312.027H159.64ZM158.64 260H211.668V258H158.64V260Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-38-inside-15_3383_11434)'
          />
          <rect
            x='106.553'
            y='470.609'
            width='52.0273'
            height='52.0273'
            transform='rotate(-90 106.553 470.609)'
            stroke='var(--black)'
            strokeOpacity='0.05'
          />
          <mask id='path-41-inside-16_3383_11434' fill='white'>
            <path d='M0 471.109L2.3179e-06 418.082L53.0273 418.082L53.0273 471.109L0 471.109Z' />
          </mask>
          <path
            d='M0 471.109L-1 471.109L-1 472.109L-4.37114e-08 472.109L0 471.109ZM2.3179e-06 418.082L2.36161e-06 417.082L-0.999998 417.082L-0.999998 418.082L2.3179e-06 418.082ZM1 471.109L1 418.082L-0.999998 418.082L-1 471.109L1 471.109ZM2.27418e-06 419.082L53.0273 419.082L53.0273 417.082L2.36161e-06 417.082L2.27418e-06 419.082ZM53.0273 470.109L4.37114e-08 470.109L-4.37114e-08 472.109L53.0273 472.109L53.0273 470.109Z'
            fill='var(--black)'
            fillOpacity='0.05'
            mask='url(#path-41-inside-16_3383_11434)'
          />
        </g>
        <path
          d='M73.8826 291.291L56.9782 296.048L49.6051 269.846L66.5095 265.089L73.8826 291.291Z'
          fill='url(#paint0_linear_3383_11434)'
        />
        <path
          d='M50.4798 292.403L45.9608 276.344L51.0321 274.917L55.5511 290.976L50.4798 292.403Z'
          fill='url(#paint1_linear_3383_11434)'
        />
        <path
          d='M71.6104 286.457L67.0914 270.398L72.1627 268.971L76.6817 285.03L71.6104 286.457Z'
          fill='url(#paint2_linear_3383_11434)'
        />
        <rect
          x='46.4916'
          y='294.438'
          width='17.561'
          height='4.39024'
          transform='rotate(-105.716 46.4916 294.438)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='66.5096'
          y='265.088'
          width='17.561'
          height='4.39024'
          transform='rotate(164.284 66.5096 265.088)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='75.0719'
          y='295.517'
          width='17.561'
          height='4.39024'
          transform='rotate(164.284 75.0719 295.517)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='56.9783'
          y='296.047'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 56.9783 296.047)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='51.0322'
          y='274.917'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 51.0322 274.917)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='78.954'
          y='289.863'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 78.954 289.863)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='73.0079'
          y='268.733'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 73.0079 268.733)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='76.9196'
          y='285.875'
          width='17.561'
          height='4.39024'
          transform='rotate(-105.716 76.9196 285.875)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M155.82 314.862L147.068 310.6L153.673 297.034L162.426 301.296L155.82 314.862Z'
          fill='url(#paint3_linear_3383_11434)'
        />
        <path
          d='M145.721 306.696L149.769 298.381L152.395 299.66L148.346 307.974L145.721 306.696Z'
          fill='url(#paint4_linear_3383_11434)'
        />
        <path
          d='M156.661 312.023L160.709 303.708L163.335 304.987L159.286 313.301L156.661 312.023Z'
          fill='url(#paint5_linear_3383_11434)'
        />
        <rect
          x='143.319'
          y='306.068'
          width='9.73465'
          height='2.43366'
          transform='rotate(-64.0372 143.319 306.068)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='162.426'
          y='301.295'
          width='9.73465'
          height='2.43366'
          transform='rotate(-154.037 162.426 301.295)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='154.754'
          y='317.049'
          width='9.73465'
          height='2.43366'
          transform='rotate(-154.037 154.754 317.049)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='147.068'
          y='310.6'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 147.068 310.6)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='152.395'
          y='299.66'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 152.395 299.66)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='158.446'
          y='316.14'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 158.446 316.14)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='163.773'
          y='305.2'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 163.773 305.2)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='159.073'
          y='313.739'
          width='9.73465'
          height='2.43366'
          transform='rotate(-64.0372 159.073 313.739)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M130.458 406.901L120.915 408.824L117.934 394.032L127.477 392.109L130.458 406.901Z'
          fill='url(#paint6_linear_3383_11434)'
        />
        <path
          d='M117.475 406.538L115.648 397.472L118.511 396.895L120.338 405.961L117.475 406.538Z'
          fill='url(#paint7_linear_3383_11434)'
        />
        <path
          d='M129.404 404.134L127.577 395.068L130.44 394.491L132.267 403.557L129.404 404.134Z'
          fill='url(#paint8_linear_3383_11434)'
        />
        <rect
          x='115.186'
          y='407.495'
          width='9.73465'
          height='2.43366'
          transform='rotate(-101.393 115.186 407.495)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='127.477'
          y='392.109'
          width='9.73465'
          height='2.43366'
          transform='rotate(168.607 127.477 392.109)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='130.938'
          y='409.286'
          width='9.73465'
          height='2.43366'
          transform='rotate(168.607 130.938 409.286)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='120.915'
          y='408.823'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 120.915 408.823)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='118.511'
          y='396.895'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 118.511 396.895)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='133.321'
          y='406.324'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 133.321 406.324)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='130.917'
          y='394.395'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 130.917 394.395)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='132.363'
          y='404.034'
          width='9.73465'
          height='2.43366'
          transform='rotate(-101.393 132.363 404.034)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M190.787 371.975L183.487 365.536L193.468 354.22L200.768 360.66L190.787 371.975Z'
          fill='url(#paint9_linear_3383_11434)'
        />
        <path
          d='M183.228 361.414L189.346 354.478L191.536 356.41L185.418 363.346L183.228 361.414Z'
          fill='url(#paint10_linear_3383_11434)'
        />
        <path
          d='M192.354 369.463L198.471 362.528L200.662 364.46L194.544 371.395L192.354 369.463Z'
          fill='url(#paint11_linear_3383_11434)'
        />
        <rect
          x='181.081'
          y='360.169'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 181.081 360.169)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='200.768'
          y='360.66'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 200.768 360.66)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='189.177'
          y='373.801'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 189.177 373.801)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='183.487'
          y='365.536'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 183.487 365.536)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='191.536'
          y='356.41'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 191.536 356.41)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='192.977'
          y='373.907'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 192.977 373.907)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='201.026'
          y='364.782'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 201.026 364.782)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='194.222'
          y='371.76'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 194.222 371.76)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M291.147 358.848L283.846 352.409L293.827 341.093L301.128 347.533L291.147 358.848Z'
          fill='url(#paint12_linear_3383_11434)'
        />
        <path
          d='M283.588 348.287L289.705 341.351L291.896 343.283L285.778 350.219L283.588 348.287Z'
          fill='url(#paint13_linear_3383_11434)'
        />
        <path
          d='M292.714 356.336L298.831 349.401L301.021 351.333L294.904 358.268L292.714 356.336Z'
          fill='url(#paint14_linear_3383_11434)'
        />
        <rect
          x='281.441'
          y='347.042'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 281.441 347.042)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='301.128'
          y='347.533'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 301.128 347.533)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='289.537'
          y='360.674'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 289.537 360.674)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='283.846'
          y='352.409'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 283.846 352.409)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='291.896'
          y='343.283'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 291.896 343.283)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='293.337'
          y='360.78'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 293.337 360.78)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='301.386'
          y='351.655'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 301.386 351.655)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='294.582'
          y='358.633'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 294.582 358.633)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M252.072 284.962L247.841 295.905L230.88 289.346L235.111 278.403L252.072 284.962Z'
          fill='url(#paint15_linear_3383_11434)'
        />
        <path
          d='M243.289 297.918L232.893 293.898L234.163 290.615L244.558 294.635L243.289 297.918Z'
          fill='url(#paint16_linear_3383_11434)'
        />
        <path
          d='M248.578 284.24L238.183 280.22L239.452 276.937L249.848 280.957L248.578 284.24Z'
          fill='url(#paint17_linear_3383_11434)'
        />
        <rect
          x='242.778'
          y='300.865'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 242.778 300.865)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='235.111'
          y='278.403'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 235.111 278.403)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='254.808'
          y='286.02'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 254.808 286.02)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='247.841'
          y='295.904'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 247.841 295.904)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='234.163'
          y='290.615'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 234.163 290.615)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='253.342'
          y='281.68'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 253.342 281.68)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='239.664'
          y='276.39'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 239.664 276.39)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='250.395'
          y='281.168'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 250.395 281.168)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M129.376 176.95L125.144 187.893L108.183 181.334L112.415 170.392L129.376 176.95Z'
          fill='url(#paint18_linear_3383_11434)'
        />
        <path
          d='M120.592 189.906L110.197 185.886L111.466 182.604L121.862 186.624L120.592 189.906Z'
          fill='url(#paint19_linear_3383_11434)'
        />
        <path
          d='M125.882 176.228L115.486 172.208L116.756 168.925L127.151 172.945L125.882 176.228Z'
          fill='url(#paint20_linear_3383_11434)'
        />
        <rect
          x='120.081'
          y='192.854'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 120.081 192.854)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='112.415'
          y='170.392'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 112.415 170.392)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='132.111'
          y='178.008'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 132.111 178.008)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='125.144'
          y='187.893'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 125.144 187.893)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='111.466'
          y='182.604'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 111.466 182.604)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='130.645'
          y='173.668'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 130.645 173.668)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='116.967'
          y='168.378'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 116.967 168.378)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='127.698'
          y='173.157'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 127.698 173.157)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M196.239 123.295L184.988 134.563L167.522 117.124L178.773 105.856L196.239 123.295Z'
          fill='url(#paint21_linear_3383_11434)'
        />
        <path
          d='M178.232 134.568L167.528 123.88L170.903 120.499L181.608 131.188L178.232 134.568Z'
          fill='url(#paint22_linear_3383_11434)'
        />
        <path
          d='M192.296 120.483L181.591 109.795L184.967 106.414L195.671 117.102L192.296 120.483Z'
          fill='url(#paint23_linear_3383_11434)'
        />
        <rect
          x='175.983'
          y='137.948'
          width='15.9234'
          height='3.98084'
          transform='rotate(-135.044 175.983 137.948)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='178.773'
          y='105.856'
          width='15.9234'
          height='3.98084'
          transform='rotate(134.956 178.773 105.856)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='199.056'
          y='126.108'
          width='15.9234'
          height='3.98084'
          transform='rotate(134.956 199.056 126.108)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='184.988'
          y='134.563'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 184.988 134.563)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='170.903'
          y='120.5'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 170.903 120.5)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='199.614'
          y='119.915'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 199.614 119.915)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='185.529'
          y='105.851'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 185.529 105.851)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='196.235'
          y='117.665'
          width='15.9234'
          height='3.98084'
          transform='rotate(-135.044 196.235 117.665)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M241.345 175.547L233.403 181.258L224.552 168.948L232.494 163.238L241.345 175.547Z'
          fill='url(#paint24_linear_3383_11434)'
        />
        <path
          d='M229.307 180.588L223.883 173.043L226.265 171.33L231.69 178.875L229.307 180.588Z'
          fill='url(#paint25_linear_3383_11434)'
        />
        <path
          d='M239.235 173.45L233.81 165.906L236.193 164.193L241.617 171.737L239.235 173.45Z'
          fill='url(#paint26_linear_3383_11434)'
        />
        <rect
          x='227.607'
          y='182.413'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 227.607 182.413)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='232.494'
          y='163.238'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 232.494 163.238)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='242.772'
          y='177.533'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 242.772 177.533)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='233.403'
          y='181.258'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 233.403 181.258)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='226.265'
          y='171.331'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 226.265 171.331)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='243.727'
          y='173.834'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 243.727 173.834)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='236.59'
          y='163.907'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 236.59 163.907)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='241.903'
          y='172.134'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 241.903 172.134)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M316.105 286.74L308.164 292.451L299.313 280.141L307.255 274.43L316.105 286.74Z'
          fill='url(#paint27_linear_3383_11434)'
        />
        <path
          d='M304.068 291.781L298.643 284.236L301.026 282.523L306.451 290.068L304.068 291.781Z'
          fill='url(#paint28_linear_3383_11434)'
        />
        <path
          d='M313.995 284.643L308.571 277.099L310.953 275.385L316.378 282.93L313.995 284.643Z'
          fill='url(#paint29_linear_3383_11434)'
        />
        <rect
          x='302.368'
          y='293.605'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 302.368 293.605)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='307.255'
          y='274.431'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 307.255 274.431)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='317.533'
          y='288.726'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 317.533 288.726)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='308.163'
          y='292.451'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 308.163 292.451)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='301.026'
          y='282.523'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 301.026 282.523)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='318.488'
          y='285.027'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 318.488 285.027)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='311.35'
          y='275.1'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 311.35 275.1)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='316.663'
          y='283.327'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 316.663 283.327)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M317.001 186.567L309.858 193.249L299.5 182.177L306.644 175.495L317.001 186.567Z'
          fill='url(#paint30_linear_3383_11434)'
        />
        <path
          d='M305.71 193.111L299.362 186.325L301.505 184.32L307.853 191.106L305.71 193.111Z'
          fill='url(#paint31_linear_3383_11434)'
        />
        <path
          d='M314.639 184.758L308.291 177.972L310.434 175.967L316.782 182.753L314.639 184.758Z'
          fill='url(#paint32_linear_3383_11434)'
        />
        <rect
          x='304.259'
          y='195.139'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 304.259 195.139)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='306.644'
          y='175.495'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 306.644 175.495)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='318.672'
          y='188.353'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 318.672 188.353)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='309.858'
          y='193.25'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 309.858 193.25)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='301.505'
          y='184.32'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 301.505 184.32)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='319.144'
          y='184.562'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 319.144 184.562)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='310.791'
          y='175.633'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 310.791 175.633)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='317.116'
          y='183.11'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 317.116 183.11)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M302.892 132.676L295.749 139.358L285.392 128.286L292.535 121.604L302.892 132.676Z'
          fill='url(#paint33_linear_3383_11434)'
        />
        <path
          d='M291.602 139.22L285.253 132.434L287.396 130.429L293.745 137.215L291.602 139.22Z'
          fill='url(#paint34_linear_3383_11434)'
        />
        <path
          d='M300.531 130.867L294.182 124.081L296.325 122.076L302.674 128.862L300.531 130.867Z'
          fill='url(#paint35_linear_3383_11434)'
        />
        <rect
          x='290.15'
          y='141.248'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 290.15 141.248)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='292.535'
          y='121.604'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 292.535 121.604)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='304.563'
          y='134.462'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 304.563 134.462)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='295.749'
          y='139.358'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 295.749 139.358)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='287.396'
          y='130.429'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 287.396 130.429)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='305.035'
          y='130.671'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 305.035 130.671)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='296.682'
          y='121.742'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 296.682 121.742)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='303.008'
          y='129.219'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 303.008 129.219)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M272.223 224.784L278.113 235.918L260.854 245.047L254.965 233.913L272.223 224.784Z'
          fill='url(#paint36_linear_3383_11434)'
        />
        <path
          d='M276.54 241.026L265.962 246.621L264.195 243.28L274.773 237.685L276.54 241.026Z'
          fill='url(#paint37_linear_3383_11434)'
        />
        <path
          d='M269.178 227.107L258.6 232.702L256.833 229.362L267.411 223.767L269.178 227.107Z'
          fill='url(#paint38_linear_3383_11434)'
        />
        <rect
          x='278.569'
          y='243.515'
          width='12.5964'
          height='3.14911'
          transform='rotate(152.124 278.569 243.515)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='254.965'
          y='233.913'
          width='12.5964'
          height='3.14911'
          transform='rotate(62.1237 254.965 233.913)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='275.007'
          y='223.312'
          width='12.5964'
          height='3.14911'
          transform='rotate(62.1237 275.007 223.312)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='278.113'
          y='235.918'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 278.113 235.918)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='264.195'
          y='243.281'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 264.195 243.281)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='270.457'
          y='221.443'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 270.457 221.443)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='256.539'
          y='228.806'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 256.539 228.806)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='267.967'
          y='223.473'
          width='12.5964'
          height='3.14911'
          transform='rotate(152.124 267.967 223.473)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M72.8293 226.275L69.9951 233.604L58.6352 229.211L61.4694 221.882L72.8293 226.275Z'
          fill='url(#paint39_linear_3383_11434)'
        />
        <path
          d='M66.9462 234.952L59.9837 232.26L60.8339 230.061L67.7964 232.754L66.9462 234.952Z'
          fill='url(#paint40_linear_3383_11434)'
        />
        <path
          d='M70.4889 225.791L63.5263 223.099L64.3766 220.9L71.3391 223.593L70.4889 225.791Z'
          fill='url(#paint41_linear_3383_11434)'
        />
        <rect
          x='66.6041'
          y='236.926'
          width='7.85789'
          height='1.96447'
          transform='rotate(-158.858 66.6041 236.926)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='61.4694'
          y='221.882'
          width='7.85789'
          height='1.96447'
          transform='rotate(111.142 61.4694 221.882)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='74.6615'
          y='226.983'
          width='7.85789'
          height='1.96447'
          transform='rotate(111.142 74.6615 226.983)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='69.995'
          y='233.604'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 69.995 233.604)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='60.834'
          y='230.061'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 60.834 230.061)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='73.6796'
          y='224.076'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 73.6796 224.076)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='64.5184'
          y='220.534'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 64.5184 220.534)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='71.7056'
          y='223.734'
          width='7.85789'
          height='1.96447'
          transform='rotate(-158.858 71.7056 223.734)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M202.92 247.183L181.524 253.203L172.191 220.039L193.588 214.018L202.92 247.183Z'
          fill='url(#paint42_linear_3383_11434)'
        />
        <path
          d='M173.298 248.591L167.578 228.264L173.997 226.458L179.717 246.785L173.298 248.591Z'
          fill='url(#paint43_linear_3383_11434)'
        />
        <path
          d='M200.044 241.065L194.324 220.738L200.743 218.932L206.463 239.258L200.044 241.065Z'
          fill='url(#paint44_linear_3383_11434)'
        />
        <rect
          x='168.25'
          y='251.166'
          width='22.2276'
          height='5.55689'
          transform='rotate(-105.716 168.25 251.166)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='193.588'
          y='214.018'
          width='22.2276'
          height='5.55689'
          transform='rotate(164.284 193.588 214.018)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='204.425'
          y='252.532'
          width='22.2276'
          height='5.55689'
          transform='rotate(164.284 204.425 252.532)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='181.524'
          y='253.204'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 181.524 253.204)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='173.997'
          y='226.458'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 173.997 226.458)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='209.339'
          y='245.376'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 209.339 245.376)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='201.813'
          y='218.631'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 201.813 218.631)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='206.764'
          y='240.329'
          width='22.2276'
          height='5.55689'
          transform='rotate(-105.716 206.764 240.329)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='62.9459'
          y='382.787'
          width='17.561'
          height='4.39024'
          transform='rotate(-91.4108 62.9459 382.787)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='89.5951'
          y='359.294'
          width='17.561'
          height='4.39024'
          transform='rotate(178.589 89.5951 359.294)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='90.3734'
          y='390.895'
          width='17.561'
          height='4.39024'
          transform='rotate(178.589 90.3734 390.895)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='72.7096'
          y='386.938'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 72.7096 386.938)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='72.1692'
          y='364.994'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 72.1692 364.994)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='95.532'
          y='386.376'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 95.532 386.376)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='94.9915'
          y='364.432'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 94.9915 364.432)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <rect
          x='94.5461'
          y='382.009'
          width='17.561'
          height='4.39024'
          transform='rotate(-91.4108 94.5461 382.009)'
          fill='var(--cream)'
          fillOpacity='0.8'
        />
        <path
          d='M80.0117 350.856L73.2766 346.723L77.4103 339.987L84.1453 344.121L80.0117 350.856Z'
          fill='url(#paint45_linear_3383_11434)'
        />
        <path
          d='M77.6993 341.195L70.9642 337.061L75.0979 330.326L81.833 334.46L77.6993 341.195Z'
          fill='url(#paint46_linear_3383_11434)'
        />
        <path
          d='M75.3869 331.534L68.6519 327.4L72.7855 320.665L79.5206 324.799L75.3869 331.534Z'
          fill='url(#paint47_linear_3383_11434)'
        />
        <path
          d='M73.0746 321.873L66.3395 317.739L70.4732 311.004L77.2082 315.138L73.0746 321.873Z'
          fill='url(#paint48_linear_3383_11434)'
        />
        <path
          d='M70.0139 311.752L63.2788 307.619L67.4125 300.884L74.1475 305.017L70.0139 311.752Z'
          fill='url(#paint49_linear_3383_11434)'
        />
        <path
          d='M180.258 258.804L182.532 266.372L174.964 268.647L172.69 261.079L180.258 258.804Z'
          fill='url(#paint50_linear_3383_11434)'
        />
        <path
          d='M175.553 267.553L177.827 275.121L170.259 277.396L167.985 269.828L175.553 267.553Z'
          fill='url(#paint51_linear_3383_11434)'
        />
        <path
          d='M170.847 276.302L173.122 283.87L165.554 286.145L163.28 278.577L170.847 276.302Z'
          fill='url(#paint52_linear_3383_11434)'
        />
        <path
          d='M165.554 286.145L167.829 293.713L160.261 295.988L157.986 288.42L165.554 286.145Z'
          fill='url(#paint53_linear_3383_11434)'
        />
        <path
          d='M160.294 318.014L168 319.765L166.249 327.471L158.543 325.719L160.294 318.014Z'
          fill='url(#paint54_linear_3383_11434)'
        />
        <path
          d='M165.587 326.42L173.293 328.171L171.542 335.877L163.836 334.126L165.587 326.42Z'
          fill='url(#paint55_linear_3383_11434)'
        />
        <path
          d='M170.881 334.826L178.586 336.577L176.835 344.283L169.129 342.532L170.881 334.826Z'
          fill='url(#paint56_linear_3383_11434)'
        />
        <path
          d='M176.835 344.283L184.541 346.035L182.79 353.741L175.084 351.989L176.835 344.283Z'
          fill='url(#paint57_linear_3383_11434)'
        />
        <path
          d='M141.539 394.407L144.189 386.963L151.634 389.613L148.984 397.057L141.539 394.407Z'
          fill='url(#paint58_linear_3383_11434)'
        />
        <path
          d='M150.513 390.145L153.163 382.7L160.607 385.35L157.958 392.795L150.513 390.145Z'
          fill='url(#paint59_linear_3383_11434)'
        />
        <path
          d='M159.486 385.883L162.136 378.438L169.581 381.088L166.931 388.533L159.486 385.883Z'
          fill='url(#paint60_linear_3383_11434)'
        />
        <path
          d='M169.581 381.088L172.231 373.643L179.676 376.293L177.026 383.738L169.581 381.088Z'
          fill='url(#paint61_linear_3383_11434)'
        />
        <path
          d='M81.1432 273.644L84.5639 266.52L91.6876 269.941L88.267 277.064L81.1432 273.644Z'
          fill='url(#paint62_linear_3383_11434)'
        />
        <path
          d='M90.516 270.352L93.9367 263.228L101.06 266.649L97.6398 273.773L90.516 270.352Z'
          fill='url(#paint63_linear_3383_11434)'
        />
        <path
          d='M99.8888 267.06L103.31 259.937L110.433 263.357L107.013 270.481L99.8888 267.06Z'
          fill='url(#paint64_linear_3383_11434)'
        />
        <path
          d='M109.262 263.769L112.682 256.645L119.806 260.066L116.385 267.189L109.262 263.769Z'
          fill='url(#paint65_linear_3383_11434)'
        />
        <path
          d='M119.015 259.686L122.435 252.562L129.559 255.983L126.138 263.106L119.015 259.686Z'
          fill='url(#paint66_linear_3383_11434)'
        />
        <path
          d='M129.559 255.983L132.98 248.859L140.103 252.28L136.683 259.403L129.559 255.983Z'
          fill='url(#paint67_linear_3383_11434)'
        />
        <path
          d='M140.62 252.114L144.041 244.991L151.164 248.411L147.744 255.535L140.62 252.114Z'
          fill='url(#paint68_linear_3383_11434)'
        />
        <path
          d='M151.164 248.411L154.585 241.287L161.709 244.708L158.288 251.832L151.164 248.411Z'
          fill='url(#paint69_linear_3383_11434)'
        />
        <path
          d='M201.295 353.977L199.581 346.263L207.295 344.549L209.009 352.263L201.295 353.977Z'
          fill='url(#paint70_linear_3383_11434)'
        />
        <path
          d='M206.628 345.597L204.914 337.882L212.629 336.168L214.343 343.883L206.628 345.597Z'
          fill='url(#paint71_linear_3383_11434)'
        />
        <path
          d='M211.962 337.216L210.248 329.502L217.962 327.788L219.676 335.502L211.962 337.216Z'
          fill='url(#paint72_linear_3383_11434)'
        />
        <path
          d='M217.295 328.835L215.581 321.121L223.296 319.407L225.01 327.121L217.295 328.835Z'
          fill='url(#paint73_linear_3383_11434)'
        />
        <path
          d='M222.439 319.597L220.725 311.883L228.439 310.169L230.153 317.883L222.439 319.597Z'
          fill='url(#paint74_linear_3383_11434)'
        />
        <path
          d='M228.692 309.738L226.978 302.024L234.693 300.31L236.407 308.024L228.692 309.738Z'
          fill='url(#paint75_linear_3383_11434)'
        />
        <path
          d='M230.676 279.307L222.775 279.175L222.907 271.274L230.809 271.406L230.676 279.307Z'
          fill='url(#paint76_linear_3383_11434)'
        />
        <path
          d='M223.771 272.166L215.869 272.034L216.002 264.133L223.903 264.265L223.771 272.166Z'
          fill='url(#paint77_linear_3383_11434)'
        />
        <path
          d='M216.865 265.025L208.963 264.893L209.096 256.992L216.997 257.124L216.865 265.025Z'
          fill='url(#paint78_linear_3383_11434)'
        />
        <path
          d='M209.614 257.141L201.712 257.008L201.845 249.107L209.746 249.239L209.614 257.141Z'
          fill='url(#paint79_linear_3383_11434)'
        />
        <path
          d='M161.394 220.309L153.493 220.177L153.625 212.275L161.527 212.408L161.394 220.309Z'
          fill='url(#paint80_linear_3383_11434)'
        />
        <path
          d='M154.488 213.168L146.587 213.036L146.719 205.134L154.621 205.267L154.488 213.168Z'
          fill='url(#paint81_linear_3383_11434)'
        />
        <path
          d='M147.583 206.027L139.681 205.895L139.814 197.993L147.715 198.126L147.583 206.027Z'
          fill='url(#paint82_linear_3383_11434)'
        />
        <path
          d='M140.332 198.142L132.43 198.01L132.563 190.108L140.464 190.241L140.332 198.142Z'
          fill='url(#paint83_linear_3383_11434)'
        />
        <path
          d='M108.859 193.398L107.876 201.24L100.035 200.257L101.018 192.416L108.859 193.398Z'
          fill='url(#paint84_linear_3383_11434)'
        />
        <path
          d='M101.016 199.495L100.033 207.336L92.1918 206.353L93.1746 198.512L101.016 199.495Z'
          fill='url(#paint85_linear_3383_11434)'
        />
        <path
          d='M93.1722 205.591L92.1893 213.432L84.3482 212.449L85.3311 204.608L93.1722 205.591Z'
          fill='url(#paint86_linear_3383_11434)'
        />
        <path
          d='M84.5521 211.95L83.5692 219.791L75.7281 218.808L76.711 210.967L84.5521 211.95Z'
          fill='url(#paint87_linear_3383_11434)'
        />
        <path
          d='M258.934 300.46L266.74 301.69L265.511 309.496L257.704 308.266L258.934 300.46Z'
          fill='url(#paint88_linear_3383_11434)'
        />
        <path
          d='M264.78 308.492L272.586 309.722L271.356 317.528L263.55 316.298L264.78 308.492Z'
          fill='url(#paint89_linear_3383_11434)'
        />
        <path
          d='M270.626 316.524L278.432 317.753L277.202 325.56L269.396 324.33L270.626 316.524Z'
          fill='url(#paint90_linear_3383_11434)'
        />
        <path
          d='M276.71 325.34L284.516 326.57L283.287 334.376L275.48 333.146L276.71 325.34Z'
          fill='url(#paint91_linear_3383_11434)'
        />
        <path
          d='M164.439 135.012L163.456 142.853L155.615 141.87L156.598 134.029L164.439 135.012Z'
          fill='url(#paint92_linear_3383_11434)'
        />
        <path
          d='M156.595 141.108L155.612 148.949L147.771 147.967L148.754 140.126L156.595 141.108Z'
          fill='url(#paint93_linear_3383_11434)'
        />
        <path
          d='M148.752 147.205L147.769 155.046L139.928 154.063L140.91 146.222L148.752 147.205Z'
          fill='url(#paint94_linear_3383_11434)'
        />
        <path
          d='M140.131 153.564L139.149 161.405L131.307 160.422L132.29 152.581L140.131 153.564Z'
          fill='url(#paint95_linear_3383_11434)'
        />
        <path
          d='M199.627 127.804L207.452 128.909L206.347 136.734L198.522 135.629L199.627 127.804Z'
          fill='url(#paint96_linear_3383_11434)'
        />
        <path
          d='M205.6 135.742L213.425 136.847L212.32 144.672L204.495 143.567L205.6 135.742Z'
          fill='url(#paint97_linear_3383_11434)'
        />
        <path
          d='M211.573 143.679L219.398 144.784L218.293 152.609L210.468 151.504L211.573 143.679Z'
          fill='url(#paint98_linear_3383_11434)'
        />
        <path
          d='M217.798 152.398L225.622 153.503L224.517 161.327L216.693 160.222L217.798 152.398Z'
          fill='url(#paint99_linear_3383_11434)'
        />
        <path
          d='M242.627 181.142L249.974 184.052L247.064 191.399L239.717 188.488L242.627 181.142Z'
          fill='url(#paint100_linear_3383_11434)'
        />
        <path
          d='M246.571 190.259L253.918 193.17L251.007 200.517L243.66 197.606L246.571 190.259Z'
          fill='url(#paint101_linear_3383_11434)'
        />
        <path
          d='M250.514 199.377L257.861 202.288L254.95 209.635L247.603 206.724L250.514 199.377Z'
          fill='url(#paint102_linear_3383_11434)'
        />
        <path
          d='M254.518 209.313L261.865 212.224L258.954 219.57L251.607 216.66L254.518 209.313Z'
          fill='url(#paint103_linear_3383_11434)'
        />
        <path
          d='M245.519 162.872L247.166 155.143L254.895 156.789L253.248 164.518L245.519 162.872Z'
          fill='url(#paint104_linear_3383_11434)'
        />
        <path
          d='M253.853 157.465L255.499 149.736L263.228 151.383L261.582 159.112L253.853 157.465Z'
          fill='url(#paint105_linear_3383_11434)'
        />
        <path
          d='M262.187 152.059L263.833 144.33L271.562 145.976L269.916 153.705L262.187 152.059Z'
          fill='url(#paint106_linear_3383_11434)'
        />
        <path
          d='M271.317 146.456L272.963 138.727L280.692 140.373L279.046 148.102L271.317 146.456Z'
          fill='url(#paint107_linear_3383_11434)'
        />
        <path
          d='M278.239 218.376L277.361 210.523L285.214 209.644L286.093 217.498L278.239 218.376Z'
          fill='url(#paint108_linear_3383_11434)'
        />
        <path
          d='M284.439 210.615L283.561 202.761L291.414 201.883L292.293 209.736L284.439 210.615Z'
          fill='url(#paint109_linear_3383_11434)'
        />
        <path
          d='M290.639 202.853L289.761 195L297.614 194.121L298.493 201.975L290.639 202.853Z'
          fill='url(#paint110_linear_3383_11434)'
        />
        <path
          d='M279.015 249.879L278.524 257.766L286.411 258.257L286.902 250.37L279.015 249.879Z'
          fill='url(#paint111_linear_3383_11434)'
        />
        <path
          d='M285.59 257.326L285.099 265.213L292.986 265.704L293.477 257.817L285.59 257.326Z'
          fill='url(#paint112_linear_3383_11434)'
        />
        <path
          d='M292.164 264.773L291.674 272.66L299.561 273.151L300.052 265.264L292.164 264.773Z'
          fill='url(#paint113_linear_3383_11434)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_3383_11434'
          x1='74.4222'
          y1='277.001'
          x2='48.2203'
          y2='284.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3383_11434'
          x1='74.4222'
          y1='277.001'
          x2='48.2203'
          y2='284.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_3383_11434'
          x1='74.4222'
          y1='277.001'
          x2='48.2203'
          y2='284.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_3383_11434'
          x1='161.311'
          y1='309.144'
          x2='147.745'
          y2='302.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_3383_11434'
          x1='161.311'
          y1='309.144'
          x2='147.745'
          y2='302.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_3383_11434'
          x1='161.311'
          y1='309.144'
          x2='147.745'
          y2='302.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_3383_11434'
          x1='131.353'
          y1='399.024'
          x2='116.562'
          y2='402.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_3383_11434'
          x1='131.353'
          y1='399.024'
          x2='116.562'
          y2='402.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_3383_11434'
          x1='131.353'
          y1='399.024'
          x2='116.562'
          y2='402.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_3383_11434'
          x1='197.603'
          y1='367.927'
          x2='186.287'
          y2='357.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_3383_11434'
          x1='197.603'
          y1='367.927'
          x2='186.287'
          y2='357.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_3383_11434'
          x1='197.603'
          y1='367.927'
          x2='186.287'
          y2='357.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_3383_11434'
          x1='297.962'
          y1='354.8'
          x2='286.647'
          y2='344.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_3383_11434'
          x1='297.962'
          y1='354.8'
          x2='286.647'
          y2='344.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_3383_11434'
          x1='297.962'
          y1='354.8'
          x2='286.647'
          y2='344.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_3383_11434'
          x1='244.65'
          y1='278.947'
          x2='238.091'
          y2='295.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_3383_11434'
          x1='244.65'
          y1='278.947'
          x2='238.091'
          y2='295.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_3383_11434'
          x1='244.65'
          y1='278.947'
          x2='238.091'
          y2='295.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_3383_11434'
          x1='121.953'
          y1='170.935'
          x2='115.394'
          y2='187.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_3383_11434'
          x1='121.953'
          y1='170.935'
          x2='115.394'
          y2='187.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_3383_11434'
          x1='121.953'
          y1='170.935'
          x2='115.394'
          y2='187.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_3383_11434'
          x1='190.319'
          y1='111.758'
          x2='172.88'
          y2='129.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_3383_11434'
          x1='190.319'
          y1='111.758'
          x2='172.88'
          y2='129.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_3383_11434'
          x1='190.319'
          y1='111.758'
          x2='172.88'
          y2='129.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_3383_11434'
          x1='238.905'
          y1='167.965'
          x2='226.595'
          y2='176.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_3383_11434'
          x1='238.905'
          y1='167.965'
          x2='226.595'
          y2='176.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_3383_11434'
          x1='238.905'
          y1='167.965'
          x2='226.595'
          y2='176.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint27_linear_3383_11434'
          x1='313.666'
          y1='279.158'
          x2='301.356'
          y2='288.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint28_linear_3383_11434'
          x1='313.666'
          y1='279.158'
          x2='301.356'
          y2='288.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint29_linear_3383_11434'
          x1='313.666'
          y1='279.158'
          x2='301.356'
          y2='288.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint30_linear_3383_11434'
          x1='313.608'
          y1='179.36'
          x2='302.536'
          y2='189.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint31_linear_3383_11434'
          x1='313.608'
          y1='179.36'
          x2='302.536'
          y2='189.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint32_linear_3383_11434'
          x1='313.608'
          y1='179.36'
          x2='302.536'
          y2='189.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint33_linear_3383_11434'
          x1='299.499'
          y1='125.469'
          x2='288.427'
          y2='135.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint34_linear_3383_11434'
          x1='299.499'
          y1='125.469'
          x2='288.427'
          y2='135.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint35_linear_3383_11434'
          x1='299.499'
          y1='125.469'
          x2='288.427'
          y2='135.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint36_linear_3383_11434'
          x1='262.122'
          y1='226.564'
          x2='271.251'
          y2='243.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint37_linear_3383_11434'
          x1='262.122'
          y1='226.564'
          x2='271.251'
          y2='243.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint38_linear_3383_11434'
          x1='262.122'
          y1='226.564'
          x2='271.251'
          y2='243.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint39_linear_3383_11434'
          x1='67.8579'
          y1='222.246'
          x2='63.4649'
          y2='233.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint40_linear_3383_11434'
          x1='67.8579'
          y1='222.246'
          x2='63.4649'
          y2='233.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint41_linear_3383_11434'
          x1='67.8579'
          y1='222.246'
          x2='63.4649'
          y2='233.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint42_linear_3383_11434'
          x1='203.603'
          y1='229.095'
          x2='170.438'
          y2='238.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint43_linear_3383_11434'
          x1='203.603'
          y1='229.095'
          x2='170.438'
          y2='238.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint44_linear_3383_11434'
          x1='203.603'
          y1='229.095'
          x2='170.438'
          y2='238.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint45_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint46_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint47_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint48_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint49_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint50_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint51_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint52_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint53_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint54_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint55_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint56_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint57_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint58_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint59_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint60_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint61_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint62_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint63_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint64_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint65_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint66_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint67_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint68_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint69_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint70_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint71_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint72_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint73_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint74_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint75_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint76_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint77_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint78_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint79_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint80_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint81_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint82_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint83_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint84_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint85_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint86_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint87_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint88_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint89_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint90_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint91_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint92_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint93_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint94_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint95_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint96_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint97_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint98_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint99_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint100_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint101_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint102_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint103_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint104_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint105_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint106_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint107_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint108_linear_3383_11434'
          x1='294.164'
          y1='207.939'
          x2='285.099'
          y2='200.756'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint109_linear_3383_11434'
          x1='294.164'
          y1='207.939'
          x2='285.099'
          y2='200.756'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint110_linear_3383_11434'
          x1='294.164'
          y1='207.939'
          x2='285.099'
          y2='200.756'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint111_linear_3383_11434'
          x1='295.435'
          y1='259.52'
          x2='286.734'
          y2='267.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint112_linear_3383_11434'
          x1='295.435'
          y1='259.52'
          x2='286.734'
          y2='267.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint113_linear_3383_11434'
          x1='295.435'
          y1='259.52'
          x2='286.734'
          y2='267.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='var(--cream)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--cream)' stopOpacity='0.4' />
        </linearGradient>
        <clipPath id='clip0_3383_11434'>
          <rect width='390' height='493' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
